module.exports = __webpack_public_path__ + "assets/img/back.ffe74151.png";